// Prepare properties for a "Form submitted" Segment event, which will be
// sent on the next page view, by virtue of being stored at
// "segmentFormSubmittedEventProperties" in local storage

import { segmentFormSubmittedEventPropertiesKey } from "../send-persisted-form-submitted-event"
import { setLocalStorageWithExpiry } from "../../utils/local-storage"

type EventProperties = {
  formId: string
  formProvider: string
  url: string
  path: string
  formName?: string
  funnelStage?: string
  nurtureTopic?: string
}

export function prepareFormSubmittedEvent(
  formId: string,
  formData: Array<any>
) {
  let eventProperties: EventProperties = {
    formId: formId,
    formProvider: "hubspot",
    url: window.location.href,
    path: window.location.pathname,
  }

  // These are hidden fields that a given Hubspot form *may* have.
  // They are in general given a default value in Hubspot.
  for (let formField of formData) {
    if (formField.name === "form_natural_name") {
      eventProperties.formName = formField.value
    }

    if (formField.name === "funnel_stage") {
      eventProperties.funnelStage = formField.value
    }

    if (formField.name === "form_asset_topic") {
      eventProperties.nurtureTopic = formField.value
    }
  }

  setLocalStorageWithExpiry(
    segmentFormSubmittedEventPropertiesKey,
    eventProperties,
    30
  )
}
